import { render } from "./ThePhamViGiaiTheThaoVH.vue?vue&type=template&id=4c780ac2"
import script from "./ThePhamViGiaiTheThaoVH.vue?vue&type=script&lang=js"
export * from "./ThePhamViGiaiTheThaoVH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__